import {
  Box,
  Button,
  Grid2,
  Step,
  StepLabel,
  Stepper,
  Typography,
  useMediaQuery,
  useTheme,
  Hidden,
  MobileStepper,
} from "@mui/material";
import {
  FunctionComponent,
  createContext,
  useContext,
  useEffect,
  useState,
} from "react";
import CandidateSearchForm from "./NewDesign/CandidateSearch";
import { Formik } from "formik";
import JobDescriptionForm from "../components/Playground/JobDescription";
import CandidateMatches from "./NewDesign/CandidateMatches";
import JobScreening from "./NewDesign/JobScreening";
import DemoScreen from "./NewDesign/DemoScreen";
import feedback from "./NewDesign/feedback";
import WelcomeScreen from "./NewDesign/welcome_screen";
import HowItWorks from "./NewDesign/how_it_works";
import IntegrationInfoScreen from "./NewDesign/integration-info-screen";
import Informations from "./NewDesign/Informations";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { StepIconProps } from "@mui/material/StepIcon";
import { styled } from "@mui/material/styles";
import StepConnector from "@mui/material/StepConnector";
import checkedIcon from "../assets/images/checkedicon.svg";
import stepperdot from "../assets/images/stepperdot.svg";
import Feedback from "./NewDesign/feedback";

// Create a context
export interface PlaygroundContextType {
  playground: PlaygroundState;
  setPlayground: React.Dispatch<React.SetStateAction<PlaygroundState>>;
}

interface PlaygroundState {
  jobDescription?: any;
  page: number;
  companyName?: string;
  jobTitle?: string;
  candidates?: any;
  selectedCandidate?: any;
  selectedCandidateId?: any;
  screeningQuestions?: any;
  city?: any;
  state?: any;
  experience?: any;
  workAuthorization?: any;
  education?: any;
  certifications?: any;
  skills?: any;
  jobDescriptionExt?: any;
  payrate?: any;
  startDate?: any;
  paytype?: any;
  fullName?: string;
  companyEmail?: string;
  phoneNumber?: string;
  userJobDescription?: string;
}

const PlaygroundContext = createContext<PlaygroundContextType | null>(null);

interface PlaygroudProps {}

const initialValues = {
  jobTitle: "",
  jobDescription: "",
  certificationLicences: [],
  skills: [],
  skillsExt: [],
  tools: [],
  toolsExt: [],
  technology: [],
  technologyExt: [],
  education: [],
  educationExt: [],
  city: [],
  state: [],
  experince: [],
  workAuthorization: [],
  jobDescriptionExt: "",
  payrate: "",
  startDate: "",
  paytype: "",
};

const Playgroud: FunctionComponent<PlaygroudProps> = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery(theme.breakpoints.between("sm", "md"));

  // State to be shared via context
  const [state, setState] = useState<PlaygroundState>({
    page: 0,
    city: "",
    state: "",
    experience: 0,
    workAuthorization: {
      citizen: false,
      permanentResident: false,
      other: false,
    },
    education: [],
    certifications: [],
    skills: [],
    jobDescriptionExt: "",
    payrate: "",
    startDate: "",
    paytype: "",
  });
  const [generatedJob, setGeneratedJob] = useState<any>(null);

  const handleGeneratedJob = (newGeneratedJob: any) => {
    setGeneratedJob(newGeneratedJob); // Update the state with the generated job
  };

  const steps = [
    "Your Info",
    "Get Job Description",
    "Source Candidates",
    "View Matches",
    "Engage Candidates",
    "Screen and Assess",
    "Seamless Integrations",
  ];

  // Get current step name for mobile display
  const getCurrentStepName = () => {
    return steps[activeStep - 2] || "";
  };

  const getStepLabel = (label: string, isMobile: boolean) => {
    // For mobile, we might want to abbreviate or simplify the labels
    if (isMobile) {
      // Map full labels to shorter versions if needed
      const shortLabels: { [key: string]: string } = {
        "Your Info": "Info",
        "Get Job Description": "Job Desc",
        "Source Candidates": "Source",
        "View Matches": "Matches",
        "Engage Candidates": "Engage",
        "Screen and Assess": "Screen",
        "Seamless Integrations": "Integrate",
      };
      return shortLabels[label] || label;
    }
    return label;
  };

  const CustomConnector = styled(StepConnector)(({ theme }) => ({
    [`& .MuiStepConnector-line`]: {
      borderColor: theme.palette.grey[400], // Default grey color
      borderTopWidth: 3, // Thickness
      position: "absolute",
      top: "0px",
      left: -9,
      right: -8,
      transform: "translateY(-50%)", // Ensure no gap
    },
    [`&.Mui-active .MuiStepConnector-line, &.Mui-completed .MuiStepConnector-line`]:
      {
        borderColor: "#0066F4", // Blue for completed steps
      },
  }));

  const CustomMobileConnector = styled(StepConnector)(({ theme }) => ({
    [`& .MuiStepConnector-line`]: {
      borderColor: theme.palette.grey[400], // Default grey color
      borderTopWidth: 3, // Thickness
      position: "absolute",
      top: -3,
      left: -12,
      right: -12,
      transform: "translateY(-50%)", // Ensure no gap
    },
    [`&.Mui-active .MuiStepConnector-line, &.Mui-completed .MuiStepConnector-line`]:
      {
        borderColor: "#0066F4", // Blue for completed steps
      },
  }));

  const CustomTabletConnector = styled(StepConnector)(({ theme }) => ({
    [`& .MuiStepConnector-line`]: {
      borderColor: theme.palette.grey[400], // Default grey color
      borderTopWidth: 3, // Thickness
      position: "absolute",
      top: 0,
      left: -8,
      right: -8,
      transform: "translateY(-50%)", // Ensure no gap
    },
    [`&.Mui-active .MuiStepConnector-line, &.Mui-completed .MuiStepConnector-line`]:
      {
        borderColor: "#0066F4", // Blue for completed steps
      },
  }));

  const [activeStep, setActiveStep] = useState(0);

  const handleNext = () => {
    if (activeStep < steps.length - 1) setActiveStep(activeStep + 1);
  };

  const handleBack = () => {
    if (activeStep > 0) setActiveStep(activeStep - 1);
  };

  const CustomStepIcon: React.FC<{ active?: boolean; completed?: boolean }> = (
    props
  ) => {
    const { active = false, completed = false } = props; // Ensure boolean values

    // Adjust icon size for mobile
    const iconSize = isMobile ? 16 : 24;

    return completed ? (
      <img
        src={checkedIcon}
        style={isMobile ? { width: "16px", height: "16px" } : undefined}
      />
    ) : active ? (
      <img
        src={stepperdot}
        style={isMobile ? { width: "16px", height: "16px" } : undefined}
      />
    ) : (
      <div
        style={{
          width: iconSize,
          height: iconSize,
          borderRadius: "50%",
          border: `2px solid ${active ? "#00C853" : "#BDBDBD"}`,
          backgroundColor: active ? "#00C853" : "transparent",
          boxSizing: "border-box",
        }}
      />
    );
  };

  useEffect(() => {
    setActiveStep(state.page);
  }, [state.page]);

  // For mobile, render a simpler version with just current step info
  const renderMobileStepper = () => {
    return (
      <Box
        sx={{
          width: "100%",
          padding: "10px 0",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Typography
          variant="body1"
          sx={{
            color: "#FFFFFF",
            fontWeight: "bold",
            mb: 1,
            textAlign: "center",
          }}
        >
          {getCurrentStepName()}
        </Typography>
        <Stepper
          activeStep={activeStep - 2}
          alternativeLabel
          connector={<CustomMobileConnector />}
          sx={{
            width: "100%",
            padding: "0",
            overflowX: "hidden",
            display: "flex",
            justifyContent: "center",
            flexWrap: "nowrap",
            alignItems: "center",
          }}
        >
          {steps.map((label, index) => (
            <Step key={index} sx={{ position: "relative" }}>
              <StepLabel
                StepIconComponent={(stepProps) => (
                  <CustomStepIcon
                    active={stepProps.active}
                    completed={stepProps.completed}
                  />
                )}
                sx={{
                  "& .MuiStepLabel-label": {
                    display: "none",
                  },
                  "& .MuiStepLabel-iconContainer": {
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  },
                }}
              ></StepLabel>
            </Step>
          ))}
        </Stepper>
      </Box>
    );
  };

  // Tablet version has fewer visible steps
  const renderTabletStepper = () => {
    return (
      <Box
        sx={{
          width: "100%",
          padding: "10px 0",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Typography
          variant="body1"
          sx={{
            color: "#FFFFFF",
            fontWeight: "bold",
            mb: 1,
            textAlign: "center",
          }}
        >
          {getCurrentStepName()}
        </Typography>
        <Stepper
          activeStep={activeStep - 2}
          alternativeLabel
          connector={<CustomTabletConnector />}
          sx={{
            width: "100%",
            padding: "0",
            overflowX: "hidden",
            display: "flex",
            justifyContent: "center",
            flexWrap: "nowrap",
            alignItems: "center",
          }}
        >
          {steps.map((label, index) => (
            <Step key={index} sx={{ position: "relative" }}>
              <StepLabel
                StepIconComponent={(stepProps) => (
                  <CustomStepIcon
                    active={stepProps.active}
                    completed={stepProps.completed}
                  />
                )}
                sx={{
                  "& .MuiStepLabel-label": {
                    display: "none",
                  },
                  "& .MuiStepLabel-iconContainer": {
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  },
                }}
              ></StepLabel>
            </Step>
          ))}
        </Stepper>
      </Box>
    );
  };

  // Desktop version shows all steps
  const renderDesktopStepper = () => (
    <Box sx={{ width: "100%", maxWidth: "1108px", padding: 2 }}>
      <Stepper
        activeStep={activeStep - 2}
        alternativeLabel
        connector={<CustomConnector />}
      >
        {steps.map((label, index) => (
          <Step key={index}>
            <StepLabel
              StepIconComponent={(stepProps) => (
                <CustomStepIcon
                  active={stepProps.active}
                  completed={stepProps.completed}
                />
              )}
              sx={{
                "& .MuiStepLabel-label": {
                  color: "#FFFFFF",
                  fontWeight: index === activeStep - 2 ? "bold" : "normal",
                },
                "& .MuiStepLabel-label.Mui-active": {
                  color: "#FFFFFF",
                },
                "& .MuiStepLabel-label.Mui-completed": {
                  color: "#FFFFFF",
                  fontWeight: 500,
                },
              }}
            >
              {label}
            </StepLabel>
          </Step>
        ))}
      </Stepper>
    </Box>
  );
  const resetForm = () => {
    setState({
      page: 0,
      city: "",
      state: "",
      experience: 0,
      workAuthorization: {
        citizen: false,
        permanentResident: false,
        other: false,
      },
      education: [],
      certifications: [],
      payrate: "",
      startDate: "",
      paytype: "",
      // Reset other fields as needed
    });
  };

  return (
    <PlaygroundContext.Provider
      value={{ playground: state, setPlayground: setState }}
    >
      <Grid2
        container
        spacing={2}
        justifyContent="center"
        sx={{ backgroundColor: "transparent" }}
      >
        {state.page > 1 && state.page < 9 && (
          <Grid2
            size={12}
            sx={{ display: "flex", justifyContent: "center", width: "100%" }}
          >
            <Box
              sx={{
                marginTop: { xs: "20px", sm: "30px", md: "40px" },
                textAlign: "center",
                width: "100%",
              }}
            >
              {/* Responsive Stepper Section */}
              <Hidden smUp>{renderMobileStepper()}</Hidden>

              <Hidden smDown mdUp>
                {renderTabletStepper()}
              </Hidden>

              <Hidden mdDown>{renderDesktopStepper()}</Hidden>
            </Box>
          </Grid2>
        )}
        <Formik
          initialValues={initialValues}
          onSubmit={(values) => {
            console.log("Form values on submit:", values);
          }}
        >
          <>
            {state.page === 0 && (
              <WelcomeScreen onNext={() => setState({ ...state, page: 1 })} />
            )}
            {state.page === 1 && (
              <HowItWorks
                onNext={() => setState({ ...state, page: 2 })}
                onPrevious={() => setState({ ...state, page: 0 })}
              />
            )}
            {state.page === 2 && (
              <Informations
                onNext={() => setState({ ...state, page: 3 })}
                onPrevious={() => setState({ ...state, page: 1 })}
              />
            )}

            {state.page === 3 && (
              <JobDescriptionForm
                setGeneratedJob={handleGeneratedJob}
                generatedJob={generatedJob}
                onPrevious={() =>
                  setState({
                    fullName: state.fullName,
                    companyEmail: state.companyEmail,
                    companyName: state.companyName,
                    phoneNumber: state.phoneNumber,
                    page: 2,
                  })
                }
              />
            )}
            {state.page === 4 && (
              <CandidateSearchForm
                handleClose={() => {
                  resetForm(); // Reset the form fields
                  setState({ ...state, page: 3 }); // Move to the previous page
                }}
              />
            )}

            {state.page === 5 && (
              <CandidateMatches
                onCloseMatch={() => setState({ ...state, page: 4 })}
              />
            )}
            {state.page === 6 && (
              <JobScreening
                setShowjobScreeing={() => setState({ ...state, page: 5 })}
              />
            )}
            {state.page === 7 && (
              <DemoScreen
                setDemoScreen={() => setState({ ...state, page: 6 })}
              ></DemoScreen>
            )}
            {state.page === 8 && (
              <IntegrationInfoScreen
                handleCloseButton={() => setState({ ...state, page: 7 })}
              />
            )}
            {state.page === 9 && (
              <Feedback
                handleStartOver={() =>
                  setState({
                    fullName: state.fullName,
                    companyEmail: state.companyEmail,
                    companyName: state.companyName,
                    phoneNumber: state.phoneNumber,
                    page: 3,
                  })
                }
              />
            )}
          </>
        </Formik>
      </Grid2>
    </PlaygroundContext.Provider>
  );
};

// Custom hook to use the Playground context
export const usePlaygroundContext = () => useContext(PlaygroundContext);

export default Playgroud;
